type Options = Partial<MobileNavigationOptions>;
import _ from 'lodash';

interface NavigationElement extends HTMLElement {
  navigation?: MobileNavigation;
}

export interface MobileNavigationOptions {
  breakpoint: number;
  childClass: string;
  visibilityClassName: string;
  openParentClassName: string;
}

export class MobileNavigation {
  static defaults = {
    breakpoint: 928,
    childClass: 'child-list-',
    openParentClassName: 'dropdown-open',
    visibilityClassName: 'is-active',
  };
  options: MobileNavigationOptions;
  element: NavigationElement;
  clickEventAlreadyBound = false;

  constructor(options: Options = {}) {
    this.options = {
      ...MobileNavigation.defaults,
      ...options,
    };
    this.bind();
  }

  bind() {
    this.windowResize();

    window.addEventListener(
      'resize',
      _.debounce(this.windowResize.bind(this, this.options.breakpoint), 150),
    );
  }

  windowResize() {
    if (window.innerWidth <= this.options.breakpoint) {
      if (!this.clickEventAlreadyBound) {
        this.addListeners();
        this.clickEventAlreadyBound = true;
      }
    } else {
      this.removeListeners();
    }
  }

  addListeners() {
    const targets = Array.from(document.querySelectorAll('.has-children'));

    for (const each of targets) {
      each.addEventListener('click', () => this.handleClick(event as Event));
    }
  }

  removeListeners() {
    const targets = Array.from(document.querySelectorAll('.has-children'));

    for (const each of targets) {
      each.removeEventListener('click', () => this.handleClick(event as Event));
    }
  }

  handleClick(event: Event) {
    event.preventDefault();
    const element = event.target as HTMLElement;
    const id = element.id;
    const target = this.options.childClass + id;

    element.classList.toggle(this.options.openParentClassName);
    this.openChild(target);
  }

  openChild(target: string) {
    const element = document.getElementById(target);

    if (element) {
      element.classList.toggle(this.options.visibilityClassName);
    }
  }
}
